// @flow
import React, { Fragment, Component } from 'react';

import { dynamicClassName } from 'utils/dynamicClassName';


import Description from 'components/fragments/text/Description';
import CardThumbnail from 'containers/fragments/CardThumbnailContainer';
import Breadcrumb from 'components/fragments/Breadcrumb';
import FooterArticle from 'components/newsletter/FooterArticle';
import FooterNews from 'components/page/FooterNews';
import BackgroundImage from 'containers/fragments/BackgroundImageContainer';
import LiveScore from 'containers/fragments/LiveScoreContainer';

import type { BlocContent } from 'types/NewsletterBloc';
import type { CardType, NewsNunType } from 'types/PageList';
import type { ArticleType } from 'types/Article';
import type { Status } from 'types/Status';

type Props = {
  title: string,
  description: Array<BlocContent>,
  label: {
    id: number,
    name: string,
    slug: string
  },
  featured_media: {
    src: string,
    legend: string,
  },
  liste_cards: Array<CardType>,
  articles: Array<ArticleType>,
  news: Array<NewsNunType>,
  status: Status,
  match: {
    params: {
      slug: string
    }
  },
  pageSlug: string,
  banniere: string,
  placeholder: string,
  organization: string,
  rencontresLive: number,
};

class PageHubDefault extends Component<Props> {

  _renderCards = () => {
    const { slug } = this.props.match.params;
    const { liste_cards } = this.props;
    const restCards = liste_cards.length % 3;
    if (liste_cards.length === 1 && liste_cards[0].object_id === 0) {
      return null;
    }
    return liste_cards.map<any>((card, index) => {
      const isOnLastLine =
        (restCards === 0 && index >= liste_cards.length - 3) ||
        (restCards !== 0 && index >= liste_cards.length - restCards);

      const classNameContainer = dynamicClassName('col col-md-6 col-lg-4 mb-2 mb-md-3');
      isOnLastLine ? classNameContainer.add('mb-lg-0') : classNameContainer.add('mb-lg-4');
      return (
        <div key={index} className={classNameContainer.build()}>
          <CardThumbnail
            url={`/${slug}/${card.object_slug}`}
            backgroundUrl={card.featured_media}
            title={card.title}
            desc={card.description}
            linkLabel={card.texte_cta}
          />
        </div>
      );
    });
  };

  render() {
    const {
      featured_media,
      title,
      description,
      articles,
      news,
      label,
      banniere,
      placeholder,
      organization,
      rencontresLive,
    } = this.props;

    

    let bannerClass = "banner banner--big";
    if (rencontresLive) {
      bannerClass = "banner banner--big banner--live-score";
    }
    return (
      <Fragment>
        <section className={bannerClass}>
          <BackgroundImage
            className="banner__thumbnail img-blue-dark"
            illustration={featured_media.src || banniere || placeholder}
            baliseImg={false}
          />
          <div className="container">
            <Breadcrumb elements={[{ name: 'accueil', to: '/' }, title]} isDark />
            <h1 className="ft-h2">{title} {' - '} {organization ?? ''}</h1>
            {description && description.length > 0 &&
            <div className="banner__desc">
              <Description description={description}/>
            </div>}
          </div>
          <LiveScore />
        </section>
        <div className="container">
          <div className="page__hub">
            <div className="row mb-6 mb-md-7 mb-lg-8">{this._renderCards()}</div>
          </div>
          { news.length > 0 &&
          <FooterNews news={news} slug={''} label={label && label.name} /> }
          { news.length === 0 && articles.length > 0 &&
          <FooterArticle articles={articles} slug={label.slug} label={label.name} /> }
        </div>
      </Fragment>
    );
  }
}

export default PageHubDefault;
